export function isNullish(v: unknown): boolean {
  return v === null || v === undefined || v === '';
}

export function formatNumber(v: unknown, locale: string = 'es-MX'): string {
  const n = Number(v);
  return isNaN(n) ? '—' : n.toLocaleString(locale);
}

/** Vista de `type: 'number'` cuando el editor es `amount`: mismos 2 decimales que el input. */
export function formatAmountNumber(v: unknown, locale: string = 'es-MX'): string {
  const n = Number(v);
  if (isNaN(n)) return '—';
  return n.toLocaleString(locale, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

export function formatCurrency(v: unknown, locale: string = 'es-MX', currency: string = 'MXN'): string {
  const n = Number(v);
  if (isNaN(n)) return '—';
  return n.toLocaleString(locale, { style: 'currency', currency, minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

function calendarDateFromUnknown(v: unknown): Date | null {
  const raw = String(v).trim();
  const isoDay = /^(\d{4})-(\d{2})-(\d{2})$/.exec(raw);
  if (isoDay) {
    const date = new Date(Number(isoDay[1]), Number(isoDay[2]) - 1, Number(isoDay[3]));
    return Number.isNaN(date.getTime()) ? null : date;
  }
  const dmy = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(raw);
  if (dmy) {
    const date = new Date(Number(dmy[3]), Number(dmy[2]) - 1, Number(dmy[1]));
    return Number.isNaN(date.getTime()) ? null : date;
  }
  const parsed = new Date(raw);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
}

export function formatDate(
  v: unknown,
  locale: string = 'es-MX',
  options: Intl.DateTimeFormatOptions = { day: '2-digit', month: '2-digit', year: 'numeric' },
): string {
  if (!v) return '—';
  const d = calendarDateFromUnknown(v);
  if (!d) return String(v);
  return d.toLocaleDateString(locale, options);
}

